import React, { useState, useEffect } from 'react'
import "./Style.css"
import '../SurveyList/Style.css'
import { Link, useNavigate } from 'react-router-dom'
import { Authme, Dashboard, getHospitalDashboard } from '../Utils/utils'
import Loader from '../../Component/Loader/Loader'
import moment from 'moment'
import Userprofile from '../../Component/Userprofile/Userprofile'
import { connect } from 'react-redux'


const SurveyDashboard = (props) => {
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboardData] = useState(null)
  const navigate = useNavigate()

  const getDashboard = async () => {
    var res = await getHospitalDashboard()
    setDashboardData(res?.data)
  }

  useEffect(() => {
    getDashboard()
  }, [])



  return (
    <>
      {loading && <Loader />}
      <div className="booking-top">
        <div className='booking-wrapper mx-auto'>
          <div className='booking-top-container p-4 d-flex justify-content-between'>
            <Userprofile />
          </div>

          <div className='booking-details-info p-3'>
            {/* Booking today */}
            <div className='booking-today-info bg-white'>
              <div className='row w-100 m-auto'>
                <div className='col-6'>
                  <span className='title'>Surveys</span>
                </div>
                {props?.userdata?.role !== 'hospital_provider' &&
                  <div className='col-6'>
                    <button className="continue-btn-res-2 " type="submit" onClick={() => navigate(`/dashboard`)}>
                      <span className="continuebtn-text-2" >Manage Bookings</span>
                    </button>
                  </div>
                }
              </div>
              {dashboard?.today && (

                <>
                  <div className='row mt-4'>
                    <div className='title w-auto'>Today Surveys</div>
                    <Link to="/today-surveys" style={{ textDecoration: "none", width: 'auto', marginLeft: 'auto' }}>
                      <span className="view-all">View All</span>
                    </Link>
                  </div>
                  <div className='survey-card' style={{ marginTop: '15px' }}>
                    <div className='card-date'>{moment(dashboard?.today?.createdAt).format('DD MMM, YYYY')}</div>
                    <div className='card-pads'>
                      <div className="survey-name">{dashboard?.today?.name ? dashboard?.today?.name : dashboard?.today?.full_name}</div>
                      <div className='top-bottom-margin'>

                        <span className='survey-age'>{dashboard?.today?.age} Years</span>
                        <span className='survey-age' style={{ textTransform: 'capitalize' }}>{dashboard?.today?.gender}</span>
                        <span className='survey-age'>{dashboard?.today?.weight} Kgs</span>
                        <span className='survey-age'>{dashboard?.today?.height_foot}.{dashboard?.today?.height_inch}ft</span>
                      </div>
                      <div className='phone-num'>+{dashboard?.today?.phone_number}</div>
                      <div className='row btn-rows'>
                        <button className='outline-btn-2 ' type='submit' onClick={() => navigate(`/surveystepone?id=${dashboard?.today?._id}&edit=true`)}>
                          <span className='continuebtn-text cont-font' >Edit Now</span>
                        </button>
                        <button className='continue-btn-2 ' type='submit' onClick={() => navigate(`/survey-detail?id=${dashboard?.today?._id}`)}>
                          <span className='continuebtn-text cont-font' >View Now</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </>

              )}
            </div>
            {/* close Booking info */}


            {/* Past Bookings */}
            {dashboard?.past && (
              <div className='booking-today-info bg-white'>
                <div className='row'>
                  <div className='title w-auto'>Past Surveys</div>
                  <Link to="/past-surveys" style={{ textDecoration: "none", width: 'auto', marginLeft: 'auto' }}>
                    <span className="view-all">View All</span>
                  </Link>
                </div>
                <div className='survey-card' style={{ marginTop: '15px' }}>
                  <div className='card-date'>{moment(dashboard?.past?.createdAt).format('DD MMM, YYYY')}</div>
                  <div className='card-pads'>
                    <div className="survey-name">{dashboard?.past?.name ? dashboard?.past?.name : dashboard?.past?.full_name}</div>
                    <div className='top-bottom-margin'>

                      <span className='survey-age'>{dashboard?.past?.age} Years</span>
                      <span className='survey-age' style={{ textTransform: 'capitalize' }}>{dashboard?.past?.gender}</span>
                      <span className='survey-age'>{dashboard?.past?.weight} Kgs</span>
                      <span className='survey-age'>{dashboard?.past?.height_foot}.{dashboard?.past?.height_inch}ft</span>
                    </div>
                    <div className='phone-num'>+{dashboard?.past?.phone_number}</div>
                    <div className='row btn-rows'>
                      <button className='outline-btn-2 ' type='submit' onClick={() => navigate(`/surveystepone?id=${dashboard?.past?._id}&edit=true`)}>
                        <span className='continuebtn-text cont-font' >Edit Now</span>
                      </button>
                      <button className='continue-btn-2 ' type='submit' onClick={() => navigate(`/survey-detail?id=${dashboard?.past?._id}`)}>
                        <span className='continuebtn-text cont-font' >View Now</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* close Past Bookings */}
            {/* {dashboard?.past == null && dashboard?.today == null &&
              <>
                <div className='row w-100 m-auto'>
                  <div className='col-8'>
                    <span className='title'>Surveys</span>
                  </div>
                  {props?.userdata?.role !== 'hospital_provider' &&
                    <div className='col-4'>
                      <button className="continue-btn-res-2 " type="submit" onClick={() => navigate(`/dashboard`)}>
                        <span className="continuebtn-text-2" >Manage Bookings</span>
                      </button>
                    </div>
                  }
                </div>

                <img src="/images/noSurvey.png" className='no-survey' />
                <div className='title-2'>No Surveys</div>
                <div className='title-3'>Please take a survey to see the list</div>
              </>
            } */}
            <button className="continue-btn-res padding-btn" type="submit" onClick={() => navigate(`/surveystepone`)}>
              <span className="continuebtn-text">+ Add New Survey</span>
            </button>



          </div>
        </div>
      </div>
    </>

  )
}

const mapDispatchToProps = {
}
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SurveyDashboard);